export enum Scenarios {
  cart1 = `cart1`,
  productDetailsPage1 = `pdp1`,
  productDetailsPage2 = `pdp2`,
}
